export const MAIN = '/';
export const LOGIN = '/login';
export const SEA_MAP = '/sea-map';
